export const changePasswordToJSON = (obj: IPasswordChangeModel): IPasswordChange => {
	const { passwordConfirmation, ...rest } = obj
	return {
		password_confirmation: passwordConfirmation,
		...rest,
	}
}
